var OCS = OCS || {};
OCS.BootFunctions = OCS.BootFunctions || {}; // Functions placed here will be ran at different points in the boot sequence
OCS.BootFunctions.application = OCS.BootFunctions.application || {};

OCS.WxBriefing = OCS.WxBriefing || {};
OCS.WxBriefing.Classes = OCS.WxBriefing.Classes || {};
OCS.WxBriefing.Live = OCS.WxBriefing.Live || {};
OCS.WxBriefing.Functions = OCS.WxBriefing.Functions || {};
/**
 * PreferencesManager Class
 *
 * This class manages the Preferences Menu of the weather briefing page.
 *
 * @module UI
 * @submodule Managers
 * @class PreferencesManager
 * @constructor
 * @requires jQuery 1.7.1+ http://jquery.com/
 * @requires Moolite 1.0.1+
 *
 */
OCS.WxBriefing.Classes.PreferencesManager = new Class({
    Implements: [OCS.WxBriefing.Classes.SingletonManager],
    manager_name: 'PreferencesManager',
    preferences_menu_open: false,
    events: {},
    options: {
        county_limit: 15,
        update_preferences_location: '/index.php/api/weather_briefing/update_preferences/format/json',
        wait_before_updating_advisories: 4000, // time in milliseconds before resetting active advisories after last click
        event_namespace: ".preferences_manager_event",
        panel_config_container_id: "panel_config_container"
    },
    request: {update: null, save: null},
    init: function (op) {
        this.setOptions(op);
        if (OCS.Constants.DEBUG) {
            OCS.console.debug_text('OCS.WxBriefing.Live.UI.PreferencesManager initialized');
        }
        var em = OCS.WxBriefing.Functions.get_event_manager();
        if (this.events.settings_click) {
            em.unsubscribe(this.events.settings_click);
        }
        this.events.settings_click = em.subscribe({'event_name': "click", "callback": this.handle_preferences_btn.bind(this), selector: 'header .settings_menu .settings_btn', "specific_event": true, fire_immediately: true, prevent_default: true});

        this.init_ajax();

    },
    init_ajax: function () {
        var am = OCS.Functions.get_ajax_manager();
        this.request.update = am.request("update_preferences", {
            url: this.options.update_preferences_location,
            dataType: "json",
            type: "POST",
            storeCompletedReq: 0
        }).addEvent('success', function (response) {
            var data = response.json.data;
            if (data.success) {
                var pass = response.request.get_passthrough_ops();
                OCS.User.update_user_preference(pass.key, pass.value);
                if (pass.callback) {
                    pass.callback();
                }
            } else {
                //alert(data.msg);
            }
        }.bind(this));

    },
    handle_preferences_btn: function () {
        if (!this.preferences_menu_open) {
            this.open_preferences_menu();
        } else {
            this.close_preferences_menu();
        }
    },
    open_preferences_menu: function () {
        $('#preferences_menu_container').remove();
        var data = OCS.User.get_user_preferences();
        data = this.get_preferences_objects(data);
        data.wind_arrows = data.wind_arrows == 0 ? false : true;
        var tm = OCS.WxBriefing.Functions.get_template_manager();
        var preferences_menu = tm.get_html('preferences_menu', data);
        $('body').append(preferences_menu);
        $('#settings_btn').addClass('active');
        this.preferences_menu_open = true;
        this.init_preferences_handlers();
        OCS.WxBriefing.Live.UI.send_analytic_event({'category': 'Preferences', 'action': "open"});
    },
    refresh_preferences_menu: function () {
        var data = OCS.User.get_user_preferences();
        data = this.get_preferences_objects(data);
        var tm = OCS.WxBriefing.Functions.get_template_manager();
        $('#backdrop_prefs').remove();
        $('#preferences_menu_container').remove();
        var preferences_menu = tm.get_html('preferences_menu', data);
        $('body').append(preferences_menu);
        this.init_preferences_handlers();
    },
    get_preferences_objects: function (data) {
        data.home_county_obj = this.translate_id_to_county_obj(data.home_county);
        if (OCS.Constants.SITES.hasOwnProperty(data.home_stid)) {
            data.home_stid_obj = OCS.Constants.SITES[data.home_stid];
        } else {
            data.home_stid_obj = {};
        }
        if (data.radar) {
            data.radar_obj = OCS.Viewer.Live.Utilities.array_has_object_with_prop(OCS.Constants.RADAR_LOCATIONS, {'id': data.radar.toUpperCase()});
        }
        var panel_config = OCS.WxBriefing.Functions.get_url_manager().current_url_state.panel_config;
        data.panel_config_obj = OCS.Constants.PANEL_LAYOUTS[panel_config];

        var about_manager = OCS.WxBriefing.Functions.get_about_manager();
        data.about = about_manager.draw().get('html');
        data.ww_counties_text = this.display_ww_counties();
        data.displayCountyList = false;
        if (data.ww_counties_text.length) {
            data.displayCountyList = true;
        }
        return data;
    },
    init_preferences_handlers: function () {
        this.handle_input_range_update(null, $('#preferences_menu_container input[type="range"]'));
        $('#preferences_menu_container input[type="range"]').unbind('change' + this.options.event_namespace).bind('change' + this.options.event_namespace, this.handle_input_range_update.bind(this));
        $('#preferences_menu_container input[type="range"]').unbind('mouseup' + this.options.event_namespace).bind('mouseup' + this.options.event_namespace, this.handle_animation_slider.bind(this));

        $('#preferences_menu_container select[name="bgcolor"]').unbind('change' + this.options.event_namespace).bind('change' + this.options.event_namespace, this.handle_bgcolor_selector.bind(this));

        $('#preferences_menu_container').unbind('click' + this.options.event_namespace).bind('click' + this.options.event_namespace, function (e) {
            var target = $(e.target).first();
            if (target.hasClass('home_county')) {
                this.home_county_handler(target, e);
            }
            if (target.hasClass('home_stid')) {
                this.home_stid_handler(target, e);
            }
            if (target.hasClass('panel_layout')) {
                this.panel_layout_handler(target, e);
            }
            if (target.hasClass('radar')) {
                this.radar_handler(target, e);
            }
            if (target.hasClass('ww_counties')) {
                this.ww_counties_handler(target, e);
            }
            if (target.hasClass('wind_arrows')) {
                this.wind_arrows_handler(target, e);
            }
            if (target.hasClass('preferences_panel_close')) {
                this.close_preferences_menu();
            }
        }.bind(this));

        $('.default_config').off('click' + this.options.event_namespace).on('click' + this.options.event_namespace, function (e) {
            if ($('.default_config').hasClass('sprite-default-unselected')) {
                $('.default_config').removeClass('sprite-default-unselected').addClass('sprite-default-selected');
            } else {
                $('.default_config').removeClass('sprite-default-selected').addClass('sprite-default-unselected');
            }

        });
    },
    home_county_handler: function (target, e) {
        OCS.WxBriefing.Live.UI.load_county_selector('Select your home county', this.handle_county_selector.bind(this), 1);
    },
    home_stid_handler: function (target, e) {
        OCS.WxBriefing.Live.UI.load_site_selector('Select your default Mesonet site', this.handle_site_selector.bind(this), target);
    },
    panel_layout_handler: function (target, e) {
        var layouts = OCS.Utilities.clone_object(OCS.Constants.PANEL_LAYOUTS);

        layouts[OCS.WxBriefing.Functions.get_url_manager().current_url_state.panel_config].active = true;
        var tm = OCS.WxBriefing.Functions.get_template_manager();

        var popup = new OCS.WxBriefing.Classes.Popup(document.id("popup_obj_container"), {});
        popup.set_popup_data(Elements.from(tm.get_html('panel_config_chooser', {layouts: Object.values(layouts)})));
        popup.open_form();

        var panel_config_container = document.id(this.options.panel_config_container_id);

        var panel_manager = new OCS.WxBriefing.Classes.PanelManager();
        Object.each(OCS.Constants.PANEL_LAYOUTS, function (layout, layout_class) {
            panel_manager.build_panel_config(layout, {
                'type': 'thumb_' + layout.template,
                'panel_count': 0,
                'panel_container': panel_config_container.getElement('.' + layout.template),
                'class_name': "panel"
            });
        }.bind(this));
        panel_config_container.getElements('.thumb_container').addEvent('click', this.handle_panel_choose_click.bind(this));
        popup.set_title('Select your panel layout');

    },
    handle_panel_choose_click: function (event) {
        var target = event.event.currentTarget;
        var panel_config = target.getProperty('data-panel_config');
        target.getSiblings().removeClass('active');
        target.addClass('active');
        OCS.WxBriefing.Functions.get_url_manager().update_url_state({panel_config: panel_config}, 0);
        document.id('preferences_menu_container').getElement('.panel_layout').set('html', target.getElement('span').get('html'));
    },
    radar_handler: function (target, e) {
        OCS.WxBriefing.Live.UI.load_radar_selector(null, this.handle_radar_selector.bind(this), target);
    },
    ww_counties_handler: function (target, e) {
        OCS.WxBriefing.Live.UI.load_county_selector('Select up to ' + this.options.county_limit + ' counties', this.handle_multiple_county_selector.bind(this), this.options.county_limit);
    },
    wind_arrows_handler: function (target, e) {
        var value = document.getElementById('wind_arrows').checked;
        if (value === true || value === 'true') {
            value = 0;
        }
        if (value === false || value === 'false') {
            value = 1;
        }
        this.update_user_preference('wind_arrows', value);
    },
    save_config_handler: function (target, e) {
        var config_container = $('.save_config_container', '#preferences_menu_container');
        var default_config = $('.default_config', '#preferences_menu_container');
        if (config_container.is(":visible")) {
            config_container.slideUp();
            default_config.slideUp();
            $(target).html('Save');
        } else {
            config_container.slideDown();
            default_config.slideDown();
            config_container.find('input[type=text]').val('');
            $(target).html('Cancel');
        }
    },
    persist_config_handler: function (target, e) {
        var name = $('input[name=config_name]', '#preferences_menu_container').val();
        if (name.length) {
            var default_config = $('.default_config').hasClass('sprite-default-selected') ? 1 : 0;
            this.request.save.send({config_name: name, hashstring: window.location.hash, default_config: default_config});

        }
    },
    handle_input_range_update: function (e, currentTarget) {
        var target = (OCS.Viewer.Live.Utilities.is_object(e)) ? $(e.target) : $(currentTarget);
        var val = (target.val() - target.attr('min')) / (target.attr('max') - target.attr('min'));

        if ($('html').hasClass('msie')) {
            // IE uses the ::-ms-fill-lower and ::-ms-fill-upper pseudos, so we don't need
            // to handle this in code
        } else if (!$('html').hasClass('msie') && $.browser.mozilla) {
            target.css('background-image', '-moz-gradient(linear, left top, right top, ' + 'color-stop(' + val + ', #4eb7cd), ' + 'color-stop(' + val + ', #cecece)' + ')');
        } else {
            target.css('background-image', '-webkit-gradient(linear, left top, right top, ' + 'color-stop(' + val + ', #4eb7cd), ' + 'color-stop(' + val + ', #cecece)' + ')');
        }
    },
    close_preferences_menu: function () {
        $('#settings_btn').removeClass('active');
        $('#preferences_menu_container, #backdrop_prefs').remove();
        this.preferences_menu_open = false;
    },
    update_user_preference: function (key, value, callback) {
        var am = OCS.Functions.get_ajax_manager();
        if (value !== OCS.User.get_user_preference(key)) {
            var data = {};
            data[key] = value;
            var req = am.request("update_preferences_" + key, {
                url: this.options.update_preferences_location,
                dataType: "json",
                type: "POST",
                storeCompletedReq: 0,
                passthrough_ops: {"key": key, "value": value, "callback": callback}
            }, true);
            req.addEvent('success', this.on_update_success.bind(this));
            req.send({data: data});
            return true;
        }
        return false;
    },
    on_update_success: function (response) {
        var ops = response.request.get_passthrough_ops();
        var data = response.json;
        if (data.success) {
            OCS.User.update_user_preference(ops.key, ops.value);
            if (ops.callback) {
                ops.callback();
            }
        } else {
            //alert(data.msg);
        }
    },
    translate_id_to_county_obj: function (id) {
        var county_obj;
        var id_upper = id.toUpperCase();
        if (!OCS.Constants.WATCHED_COUNTIES_OBJS[id_upper]) {
            id_upper = OCS.Utilities.object_has_object_with_cond(OCS.Constants.WATCHED_COUNTIES_OBJS, function (value, key) {
                if (id_upper === value.CID || id_upper === value.ID) {
                    return true;
                }
                return false;
            });
        }
        county_obj = OCS.Constants.WATCHED_COUNTIES_OBJS[id_upper];
        return county_obj;
    },
    handle_county_selector: function (feature) {
        if (feature && feature.selected) {
            var county_obj = this.translate_id_to_county_obj(feature.selected[0]);
            $('.home_county', '#preferences_menu_container').text(county_obj.NAME);
            if (this.update_user_preference('home_county', county_obj.ID.toLowerCase())) {
                if (!OCS.WxBriefing.Live.UI.keep_overlays_open) {
                    OCS.WxBriefing.Functions.get_ui_menu().reset_menu();
                    var popup = OCS.WxBriefing.Live.UI.get_popup_obj('county_selector_popup');
                    popup.close_form();
                }
                OCS.WxBriefing.Live.UI.keep_overlays_open = false;
            }
        }
    },
    handle_multiple_county_selector: function (county_list) {
        this.update_user_preference('ww_counties', county_list.selected.join(), function () {
            this.refresh_preferences_menu();
            OCS.WxBriefing.Live.NoticeManager.get_latest_advisories();
        }.bind(this), this.options.wait_before_updating_advisories);
    },
    display_ww_counties: function () {
        var output = [];
        var ww_counties = OCS.User.get_user_preference('ww_counties').split(',');
        Object.each(ww_counties, function (ww_county) {
            var ww_county_obj = this.translate_id_to_county_obj(ww_county);
            if (ww_county_obj) {
                output.push(ww_county_obj);
            }
        }.bind(this));
        return output;
    },
    handle_site_selector: function (data) {
        $('.home_stid', '#preferences_menu_container').text(data.name);
        if (this.update_user_preference('home_stid', data.id)) {
            if (!OCS.WxBriefing.Live.UI.keep_overlays_open) {
                OCS.WxBriefing.Functions.get_ui_menu().reset_menu();
                var popup = OCS.WxBriefing.Live.UI.get_popup_obj('site_selector_popup');
                popup.close_form();
            }
            OCS.WxBriefing.Live.UI.keep_overlays_open = false;
        }
    },
    handle_bgcolor_selector: function (e) {
        var color = $(e.target).val().toLowerCase();
        this.update_user_preference('map_bgcolor', color);
    },
    handle_radar_selector: function (data) {
        $('.radar', '#preferences_menu_container').text(data.id.toUpperCase() + ' ' + data.name);
        this.update_user_preference('radar', data.id.toUpperCase());
        if (!OCS.WxBriefing.Live.UI.keep_overlays_open) {
            OCS.WxBriefing.Functions.get_ui_menu().reset_menu();
            var popup = OCS.WxBriefing.Live.UI.get_popup_obj('radar_selector_popup');
            popup.close_form();
        }
        OCS.WxBriefing.Live.UI.keep_overlays_open = false;
    },
    handle_animation_slider: function (e) {
        var slider = $(e.target);
        var value = -(slider.val());
        this.update_user_preference('anim_speed', value);
    },
    save_current_configuration: function () {
        console.log(window.location.hash);
    },
    handle_panel_layout_chooser: function (data, el) {
        OCS.WxBriefing.Live.UI.close_overlay();
        OCS.WxBriefing.Functions.get_ui_menu().reset_menu();
    },
    destroy: function () {
        $('.default_config').off('click' + this.options.event_namespace);
        $('#preferences_menu_container input[type="range"]').unbind('change' + this.options.event_namespace);
        $('#preferences_menu_container input[type="range"]').unbind('mouseup' + this.options.event_namespace);
        $('#preferences_menu_container select[name="bgcolor"]').unbind('change' + this.options.event_namespace);
        $('#preferences_menu_container').unbind('click' + this.options.event_namespace);
        this.remove_registered_events();
    }
}); // OCS.WxBriefing.Classes.PreferencesManager